import { createSingleEntityStore, pipeState } from '@core/ngrx-legacy';

import type { LegalAgreementsParams, LegalAgreementsPayload } from '../../types';
import { EntityStoreKey } from '../../types';

export type LegalAgreementsEntity = { openai: boolean | undefined };

const { actions, selectors, reducer, namespace } = createSingleEntityStore<LegalAgreementsEntity>()(
  EntityStoreKey.legalAgreements,
  {
    customActions: adapter => ({
      fetchOne: (state, payload: LegalAgreementsParams) => adapter.markAsPending(state),
      fetchOneSuccess: (state, payload: LegalAgreementsEntity) =>
        pipeState(
          state,
          state => adapter.save(state, payload),
          next => adapter.markAsLoaded(next),
        ),
      fetchOneFailed: (state, payload) =>
        pipeState(
          state,
          state => adapter.setError(state, payload),
          state => adapter.save(state, payload),
          next => adapter.markAsLoaded(next),
        ),
      updateOne: (state, payload: LegalAgreementsPayload) => adapter.markAsPending(state),
      updateOneSuccess: (state, payload: LegalAgreementsEntity) =>
        pipeState(
          state,
          state => adapter.save(state, payload),
          next => adapter.markAsLoaded(next),
        ),
      updateOneFailed: (state, payload) =>
        pipeState(
          state,
          state => adapter.setError(state, payload),
          state => adapter.save(state, payload),
          next => adapter.markAsLoaded(next),
        ),
    }),
    initialState: {
      loaded: false,
      failed: false,
      pending: false,
      error: null,
      data: {
        openai: undefined,
      },
    },
  },
);

export {
  actions as LegalAgreementsActions,
  reducer as LegalAgreementsReducer,
  selectors as LegalAgreementsSelectors,
  namespace as LegalAgreementsNamespace,
};
